import React from 'react';
import { SwitchProps } from 'antd';

import {
  StyledAntdSwitch,
} from './style';

const CVSwitch = (props: SwitchProps): JSX.Element => (
  <StyledAntdSwitch {...props} />
);

export default CVSwitch;
